import { Deferred } from './deferred';

const configDeferred = new Deferred();

export function getPublicConfig() {
  return configDeferred.promise;
}

export function setPublicConfig(config) {
  configDeferred.resolve(config);
}
